<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">Create User</h1>
        <p class="user-mgmt-page__subtitle">Add a new admin or staff user to the platform.</p>
      </div>
    </header>

    <form #rpform="ngForm">
      <section class="user-mgmt-page__form-card">
        <div class="user-mgmt-page__form-grid">
          <div class="form-fields">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>First Name</mat-label>
              <input matInput class="form-control-textbox" [(ngModel)]="createuserobj.firstName" name="fname" required />
            </mat-form-field>
          </div>

          <div class="form-fields">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Last Name</mat-label>
              <input matInput class="form-control-textbox" [(ngModel)]="createuserobj.lastName" name="lastname" required />
            </mat-form-field>
          </div>

          <div class="form-fields form-fields--full">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Email</mat-label>
              <input matInput class="form-control-textbox" [(ngModel)]="createuserobj.userName" name="username" required />
            </mat-form-field>
          </div>

          @if (canSetPassword) {
            <div class="form-fields form-fields--full">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Password (optional)</mat-label>
                <input
                  matInput
                  type="password"
                  class="form-control-textbox"
                  [(ngModel)]="createuserobj.password"
                  name="password"
                  autocomplete="new-password" />
              </mat-form-field>
              <small class="user-mgmt-page__field-hint">Leave blank to use the default password. If set: min 10 chars, upper, lower, and a number.</small>
            </div>
          }

          <div class="form-fields form-fields--full">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Select Roles</mat-label>
              <mat-select placeholder="Select" name="userRoles" multiple [(ngModel)]="selectedRoles">
                @for (roles of applicationRoles; track roles) {
                  <mat-option [value]="roles.id">
                    {{ roles.description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-fields">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Province</mat-label>
              <mat-select placeholder="Select Province" name="province" [(ngModel)]="createuserobj.province" (selectionChange)="bindBranches()">
                @for (p of provinces; track p) {
                  <mat-option [value]="p.id">{{ p.provinceName }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          @if (showBranchSection) {
            <div class="form-fields" id="branches">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Branch</mat-label>
                <mat-select placeholder="Select Branch" name="branch" [(ngModel)]="createuserobj.branch">
                  @for (b of filteredBranchs; track b) {
                    <mat-option [value]="b.id">{{ b.branchName }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }

          @if (showorg) {
            <div class="form-fields form-fields--full" id="orgs">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Organization</mat-label>
                <mat-select placeholder="Select Organizations" name="orgs" [(ngModel)]="createuserobj.organization">
                  @for (o of filteredOrgs; track o) {
                    <mat-option [value]="o.id">{{ o.organizationName }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>

        <div class="user-mgmt-page__status-panel">
          <span class="user-mgmt-page__status-label">Account Status</span>
          <div class="toggle">
            <div class="switch-div">
              <input type="radio" name="sizeBy" [value]="true" id="active" class="active" [(ngModel)]="createuserobj.isActive" />
              <label for="active">Active</label>
            </div>
            <div class="switch-div">
              <input type="radio" name="sizeBy" [value]="false" id="inactive" class="inactive" [(ngModel)]="createuserobj.isActive" />
              <label for="inactive">Inactive</label>
            </div>
          </div>
        </div>

        <div class="user-mgmt-page__footer-actions">
          <button
            class="user-mgmt-page__btn user-mgmt-page__btn--primary"
            type="button"
            (click)="createUser(rpform)"
            [disabled]="isCreating">
            <mat-icon *ngIf="!isCreating">save</mat-icon>
            <mat-icon *ngIf="isCreating" class="create-user-spin">autorenew</mat-icon>
            {{ isCreating ? 'Creating...' : 'Create User' }}
          </button>
          <a
            routerLink="/user-list"
            class="user-mgmt-page__btn user-mgmt-page__btn--secondary"
            [class.disabled]="isCreating"
            [attr.aria-disabled]="isCreating"
            (click)="isCreating && $event.preventDefault()">
            <mat-icon>close</mat-icon>
            Cancel
          </a>
        </div>
        <p class="create-user-loading-hint" *ngIf="isCreating">Creating user, please wait...</p>
      </section>
    </form>
  </div>
</div>

<app-footer [bbapp]="true"></app-footer>
